export class EmailMessage {
    public fromEmailAddress: string;
    public subject: string;
    public htmlBody: string;
    public textBody: string;
}